import * as React from 'react';

import RelativeTime from '@core/components/display/time/RelativeTime';
import { classNames } from '@core/utils/functions/class-names';
import { NextImage } from '@research-api/utils/api/ghost/ghost-interfaces';
import Image from 'next/future/image';

import EditorialConfig from '@/EditorialConfig';

type ReasearchTeaserProps = {
    headerTitle: string;
    title: string;
    slug: string;
    description?: string;
    image: NextImage | null;
    authorTitle: string;
    authorUrl: string;
    publishedAt: number;
    className?: string;
};

const ReasearchTeaser = (props: ReasearchTeaserProps) => {
    const { headerTitle, title, description, image, authorTitle, authorUrl, publishedAt, slug, className } = props;

    return (
        <div className={classNames('flex flex-col justify-start items-start gap-3', className)}>
            <div className="flex flex-col justify-start self-stretch gap-2">
                {image && (
                    <a
                        href={`${EditorialConfig.blockworksResearchUrl}/research/${slug}`}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <div className="block xl:hidden">
                            <Image src={image.url} className="w-full" alt={title} width={600} height={336} />
                        </div>
                        <div className="hidden xl:block">
                            <Image src={image.url} className="w-full" alt={title} width={300} height={168} />
                        </div>
                    </a>
                )}
                <div className="flex justify-start items-center self-stretch gap-1">
                    <p className="flex-grow text-xs uppercase text-primary">{headerTitle}</p>
                </div>
                <div className="flex justify-start items-start self-stretch gap-2.5">
                    <a
                        href={`${EditorialConfig.blockworksResearchUrl}/research/${slug}`}
                        target="_blank"
                        className="flex-grow text-[22px] font-headline hover:text-primary"
                        rel="noreferrer"
                    >
                        {title}
                    </a>
                </div>
                <div className="flex justify-start items-start self-stretch gap-2.5">
                    <p className="flex-grow text-base text-left text-[#6a6a6a]">{description}</p>
                </div>
                <div className="flex justify-start items-start self-stretch gap-1">
                    <div className="flex justify-start items-start relative">
                        <p className="text-xs uppercase text-light-gray">
                            by{' '}
                            <a
                                href={authorUrl}
                                className="text-primary hover:text-dark"
                                target="_blank"
                                rel="noreferrer"
                            >
                                {authorTitle}
                            </a>
                        </p>
                    </div>
                    {publishedAt !== 0 && (
                        <div className="flex justify-start items-start gap-1">
                            <p className="text-xs uppercase text-light-gray">/</p>
                            <p className="text-xs uppercase text-light-gray">
                                <RelativeTime date={publishedAt} />
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ReasearchTeaser;
